import { ConsolePage } from './pages/ConsolePage';
import { AuthProvider } from './contexts/AuthContext';
import { ToolProvider } from './contexts/ToolContext';
import { RealtimeServiceProvider } from './contexts/RealtimeServiceContext';
import { FabricServiceProvider } from './contexts/FabricServiceContext';
import { ThemeProvider } from './contexts/ThemeContext';
import './App.scss';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <ToolProvider>
          <FabricServiceProvider>
            <RealtimeServiceProvider>
              <div data-component="App">
                <ConsolePage />
              </div>
            </RealtimeServiceProvider>
          </FabricServiceProvider>
        </ToolProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
